import React from "react";
import { Plural, Trans } from "@lingui/macro";
import * as styles from "./CruiseSummary.module.scss";
import { Button } from "@silversea-ssc/ui-components-react";
import PriceFromBox from "components/PriceFromBox/PriceFromBox";
import PricePromos from "components/PriceFromBox/PricePromos";
import { CruisePriceFrom } from "types/api/suite_price.d";
import DateOnlyFormat from "components/DateOnlyFormat";
import { LocationSpecificOffer } from "components/useLocationSpecificOffers/types";

export interface CruiseSummaryProps {
  cruiseName?: string | JSX.Element;
  price?: CruisePriceFrom;
  departureDate?: string;
  arrivalDate?: string;
  days?: number;
  offers?: LocationSpecificOffer[];
  raqUrl?: string;
}

const CruiseSummary: React.FC<CruiseSummaryProps> = ({
  cruiseName,
  price,
  departureDate,
  arrivalDate,
  days,
  offers,
  raqUrl
}) => {
  return (
    <div className={styles.summary} data-content-name="sticky_cruise_summary">
      <div className={styles.name}>{cruiseName}</div>
      <div className={styles.date}>
        <DateOnlyFormat
          value={departureDate}
          format={{
            year: "numeric",
            month: "long",
            day: "numeric"
          }}
        />{" "}
        to{" "}
        <DateOnlyFormat
          value={arrivalDate}
          format={{
            year: "numeric",
            month: "long",
            day: "numeric"
          }}
        />
        <div className={styles.days}>
          <Plural value={days || 0} one="# DAY" other="# DAYS" />
        </div>
      </div>
      <div className={styles.priceColumn}>
        {price && (
          <PriceFromBox
            price={price}
            className={styles.price}
            promoClassName={styles.promo}
          >
            {offers && <PricePromos offers={offers} variant="inline" />}
          </PriceFromBox>
        )}
      </div>

      <div className={styles.cta}>
        <Button
          variant="primary"
          centerText
          href={raqUrl}
          data-content-piece="request_a_quote"
        >
          <Trans>Request a Quote</Trans>
        </Button>
      </div>
    </div>
  );
};

export default CruiseSummary;
